import loadable from '@loadable/component';

const Component = loadable(() => import('./Drydock'));

export default Component;
